module.exports = __webpack_public_path__ + "6990cccdd317fa69fb45f1c6aa091954.png";